import React, {memo} from 'react'
import cx from 'classnames'

/* Styles */
import s from './vas-skeleton.scss'

const VASBoxesSkeleton = memo(({className}) => {
  return (
    <div className={cx(s.vasSkeletonWrapper, className)}>
      <div className={s.vasSkeletonContainer}>
        <div className={s.vasSkeleton}></div>
        <div className={cx(s.vasSkeleton, s.vasSkeletonDescription)}></div>
        <div className={cx(s.vasSkeleton, s.vasSkeletonDescription)}></div>
      </div>
    </div>
  )
})

export default VASBoxesSkeleton
